module.exports = __webpack_public_path__ + "img/p47.09dd7f81.png";